import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  TextField
} from '@mui/material';
import { observer } from 'mobx-react-lite';

import axios from '../../lib/axios';
import useStores from '../../stores/useStores';

const AddAccount = () => {
  const { modalStore, userStore } = useStores();
  const [userExists, setUserExists] = useState(null);
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState(null);
  const [message, setMessage] = useState(null);
  const [name, setName] = useState(null);

  const handleClose = () => {
    modalStore.setModal(null);
  };

  const search = email => {
    axios
      .get('/user/exists', {
        params: {
          email
        }
      })
      .then(response => {
        if (response.data.data !== null) {
          setUser(response.data.data);
          setUserExists(true);
        } else {
          setUser(null);
          setUserExists(false);
        }
      });
  };

  const handleChange = async event => {
    const { name } = event.target;
    if (name === 'e-mail') {
      setEmail(event.target.value);
      search(event.target.value);
    }

    if (name === 'message') {
      setMessage(event.target.value);
    }

    if (name === 'name') {
      setName(event.target.value);
    }
  };

  const handleAdd = async () => {
    const groupId = userStore.user.group.id;
    if (userExists) {
      const { data } = await axios.post(
        `/group/${groupId}/relationships/users`,
        {
          data: [
            {
              ...user,
              message
            }
          ]
        }
      );
      handleClose();
      const groupMembers = [...userStore.groupMembers];
      groupMembers.push(...data.data);

      userStore.groupMembers = groupMembers;
    }

    if (!userExists) {
      const { data } = await axios.post(
        `/group/${groupId}/relationships/users`,
        {
          data: [
            {
              email,
              message,
              name
            }
          ]
        }
      );
      handleClose();
      const groupMembers = [...userStore.groupMembers];
      groupMembers.push(...data.data);
      userStore.groupMembers = groupMembers;
    }

    // UserStore.fetchGroupMembers();
    modalStore.setModal('team-manager');
  };

  const isOpen = modalStore.open === 'add-account';
  let helperText = '';

  if (userExists === true) {
    helperText = 'User Exists, invite  to join the group will be sent';
  }

  if (userExists === false) {
    helperText = 'User does not exist and will be created';
  }

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={isOpen}
    >
      <DialogTitle id="simple-dialog-title">Add Account</DialogTitle>
      <DialogContent style={{ minWidth: 400, padding: '1rem 2rem' }}>
        <form onChange={handleChange}>
          <TextField
            fullWidth
            id="e-mail"
            name="e-mail"
            label="E-mail"
            value={email}
            helperText={helperText}
            margin="normal"
          />

          <TextField
            fullWidth
            id="name"
            name="name"
            label="Name (optional)"
            margin="normal"
            value={name}
            multiline
          />

          <TextField
            fullWidth
            id="standard-name"
            name="message"
            label="Message (optional)"
            margin="normal"
            value={message}
            multiline
          />

          <FormGroup style={{ display: 'none' }}>
            <FormControlLabel
              control={<Checkbox value="notify" />}
              label="Send notification"
            />
          </FormGroup>
        </form>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleAdd} color="primary" autoFocus>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default observer(AddAccount);
